import { Injectable } from "@angular/core";
import { UserProvider } from "../../providers/user/user";
import { Observable } from "rxjs/Observable";

@Injectable()
export class LoginProvider {

    constructor(public userProvider: UserProvider) { }

    doLogin(username: string, password: string): Observable<any> {
        return Observable.create(observer => {
            this.userProvider.login(username, password).subscribe((data) => {
                observer.next(data)
            }, err =>{
                observer.error(err)
            })
        })
    }

    forguetPassword(username: string): Observable<any> {
        return Observable.create(observer => {
            this.userProvider.forguetPassword(username).subscribe((data) => {
                observer.next(data)
            }, err =>{
                observer.error(err)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.provider.ts